import React from 'react';
import { useTranslation } from 'react-i18next';
import './footer.module.scss';

export type FooterProps = {
  additionalFooterMessage?: React.ReactElement;
};

const Footer = (props: FooterProps) => {
  const { t } = useTranslation();
  return (
    <footer className='d-flex privacy-text container justify-content-center align-items-center flex-column'>
      {props && props.additionalFooterMessage}
      <p>
        {t(
          'privacy_info',
          'We process personal information in accordance with our'
        )}
        <a href={process.env.REACT_APP_PRIVACY_LINK}>
          &nbsp;{t('privacy_link', 'Privacy Policy')}
        </a>
      </p>
    </footer>
  );
};

export default Footer;
